<template>
<div style="background:#0A1628;min-height:100vh;">
  <div class="sp-header">
    <div class="container d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center gap-2">
        <span style="font-size:24px;">🎓</span>
        <span style="color:#E8EDF4;font-weight:700;font-size:16px;">Simi Trac</span>
      </div>
      <div class="d-flex align-items-center gap-3">
        <span style="color:#8BA4C4;font-size:13px;">{{ studentName }}</span>
        <button class="sp-btn-logout" @click="logout">Logout</button>
      </div>
    </div>
  </div>

  <div class="container" style="padding-top:20px;padding-bottom:40px;">
    <h4 style="color:#E8EDF4;margin:0 0 4px;">Welcome, {{ firstName }}!</h4>
    <p style="color:#8BA4C4;font-size:13px;margin:0 0 20px;">{{ institutionName }}</p>

    <!-- Stats Cards -->
    <div class="row g-3 mb-4">
      <div class="col-6 col-md-3">
        <div class="sp-stat-card">
          <div class="sp-stat-num" style="color:#10B981;">KSh {{ fNum(wallet) }}</div>
          <div class="sp-stat-label">Wallet Balance</div>
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="sp-stat-card">
          <div class="sp-stat-num" style="color:#2E86DE;">{{ attendanceToday.length }}</div>
          <div class="sp-stat-label">Taps Today</div>
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="sp-stat-card">
          <div class="sp-stat-num" style="color:#F59E0B;">{{ daysPresent }}</div>
          <div class="sp-stat-label">Days This Month</div>
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="sp-stat-card">
          <div class="sp-stat-num" :style="{color: feeBalance > 0 ? '#EF4444' : '#10B981'}">KSh {{ fNum(feeBalance) }}</div>
          <div class="sp-stat-label">Fees Balance</div>
        </div>
      </div>
    </div>

    <!-- Today's Attendance -->
    <div class="sp-section">
      <h6 class="sp-section-title">📍 Today's Attendance</h6>
      <div v-if="attendanceToday.length">
        <div class="sp-att-item" v-for="(a, i) in attendanceToday" :key="i">
          <span class="sp-att-type">{{ formatTapType(a.tap_point_type) }}</span>
          <span class="sp-att-name">{{ a.tap_point_name || '' }}</span>
          <span class="sp-att-time">{{ formatTime(a.tapped_at) }}</span>
        </div>
      </div>
      <div v-else class="sp-empty">No attendance recorded today</div>
    </div>

    <!-- Recent Transactions -->
    <div class="sp-section">
      <h6 class="sp-section-title">💳 Recent Transactions</h6>
      <div v-if="transactions.length">
        <div class="sp-txn-item" v-for="t in transactions" :key="t.id">
          <div>
            <div class="sp-txn-desc">{{ t.description || t.category }}</div>
            <div class="sp-txn-date">{{ formatDate(t.created_at) }}</div>
          </div>
          <div :style="{color: t.type==='credit'?'#10B981':'#EF4444', fontWeight:700}">
            {{ t.type === 'credit' ? '+' : '-' }}KSh {{ fNum(t.amount) }}
          </div>
        </div>
      </div>
      <div v-else class="sp-empty">No transactions yet</div>
    </div>
  </div>
</div>
</template>

<script>
import { executeJson, simitrack } from "@/api";
export default {
  name: 'StudentPortal',
  data() {
    return {
      studentName: '', firstName: '', institutionName: '',
      wallet: 0, attendanceToday: [], transactions: [],
      daysPresent: 0, feeBalance: 0, loading: true
    };
  },
  mounted() { this.load(); },
  methods: {
    async load() {
      this.studentName = sessionStorage.getItem('userName') || '';
      this.firstName = this.studentName.split(' ')[0];
      this.institutionName = sessionStorage.getItem('institutionName') || '';
      try {
        var r = await executeJson({ function: 'getStudentDashboard' }, simitrack);
        if (r.data.success) {
          const d = r.data.data;
          this.wallet = d.wallet_balance || 0;
          this.attendanceToday = d.attendance_today || [];
          this.transactions = d.transactions || [];
          this.daysPresent = d.days_present_this_month || 0;
          this.feeBalance = d.fees?.balance || 0;
        }
      } catch(e) { console.error(e); }
    },
    formatTapType(t) {
      const m = { gate_entry:'🚪 Arrived', gate_exit:'🚶 Left', classroom:'📚 Class', bus_boarding:'🚌 Bus', bus_dropoff:'🚌 Drop-off', pos_dining:'🍽️ Dining', event:'📅 Event' };
      return m[t] || t;
    },
    formatTime(dt) { if (!dt) return ''; return new Date(dt).toLocaleTimeString('en-KE', { hour:'2-digit', minute:'2-digit' }); },
    formatDate(dt) { if (!dt) return ''; return new Date(dt).toLocaleDateString('en-KE', { day:'numeric', month:'short', hour:'2-digit', minute:'2-digit' }); },
    fNum(v) { return Number(v||0).toLocaleString(); },
    logout() { sessionStorage.clear(); localStorage.removeItem('authToken'); this.$router.push('/login'); }
  }
};
</script>

<style scoped>
.sp-header { background:#0F2847; border-bottom:1px solid #1B3A6A; padding:12px 0; }
.sp-btn-logout { background:none; border:1px solid #EF4444; color:#EF4444; border-radius:6px; padding:4px 12px; font-size:12px; cursor:pointer; }
.sp-stat-card { background:#0F2847; border:1px solid #1B3A6A; border-radius:12px; padding:16px; text-align:center; }
.sp-stat-num { font-size:24px; font-weight:800; }
.sp-stat-label { font-size:12px; color:#8BA4C4; margin-top:4px; }
.sp-section { background:#0F2847; border:1px solid #1B3A6A; border-radius:12px; padding:16px; margin-bottom:16px; }
.sp-section-title { color:#E8EDF4; font-size:15px; margin:0 0 12px; }
.sp-att-item { display:flex; align-items:center; gap:12px; padding:8px 0; border-bottom:1px solid #1B3A6A; }
.sp-att-item:last-child { border-bottom:none; }
.sp-att-type { font-size:13px; color:#E8EDF4; min-width:100px; }
.sp-att-name { font-size:12px; color:#8BA4C4; flex:1; }
.sp-att-time { font-size:13px; color:#4FC3F7; font-weight:600; }
.sp-txn-item { display:flex; justify-content:space-between; align-items:center; padding:10px 0; border-bottom:1px solid #1B3A6A; }
.sp-txn-item:last-child { border-bottom:none; }
.sp-txn-desc { font-size:14px; color:#E8EDF4; }
.sp-txn-date { font-size:11px; color:#8BA4C4; }
.sp-empty { color:#8BA4C4; text-align:center; padding:20px; font-size:13px; }
</style>
